export default __webpack_public_path__ + "icon_search.cd93cee0ea91404f7edc5cfbef098fe4.svg";